import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import UserAvatar from './UserAvatar';

loadDOMComponent({
	selector: 'react-user-avatar',
	callback: ({ container, context }) => {
		const userId = container.getAttribute('userId');
		const dataClass = container.getAttribute('data-class') || null;
		const profileImageUrl =
			container.getAttribute('profileImageUrl') || undefined;
		let dataType = container.getAttribute('data-type') || 'img';
		if (dataType !== 'img' && dataType !== 'background') {
			dataType = 'img';
		}

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<UserAvatar
						userId={userId}
						customClass={dataClass}
						type={dataType}
						profileImageUrl={profileImageUrl}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
